import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function wsUrl(code, { playerId, name, avatar }) {
  const base = BACKEND_URL.replace(/^http/, "ws");
  const qs = new URLSearchParams({ playerId, name, avatar }).toString();
  return `${base}/api/ws/${code}?${qs}`;
}

// admin auth token helpers
const TOKEN_KEY = "lostdc_admin_token";
export const adminToken = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((config) => {
  const t = adminToken.get();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function errMsg(e, fallback = "Something went wrong.") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ") || fallback;
  return fallback;
}
